<template>
  <div class="get-started-page">
    <div class="align-right" style="position: absolute; right: 0; top: 0; padding: 1rem;">
      <v-icon style="cursor:pointer" @click.prevent="$store.commit('closeGetStartedDialog')">close</v-icon>
    </div>

    <div class="left-bar">
      <div style="text-transform: uppercase;">Create PFX Brokerage Account</div>
      <h1>Let's get started</h1>
      <v-stepper v-model="stepper" vertical light>
        <v-stepper-step :complete="stepper > 1" step="1">Account Information</v-stepper-step>
        <v-stepper-content step="1"></v-stepper-content>
        <v-stepper-step :complete="stepper > 2" step="2">Confirm Account</v-stepper-step>
        <v-stepper-content step="2"></v-stepper-content>
        <v-stepper-step :complete="stepper > 3" step="3">Company Details</v-stepper-step>
        <v-stepper-content step="3"></v-stepper-content>
        <v-stepper-step :complete="false" step="4">Wait For Approval...</v-stepper-step>
      </v-stepper>
    </div>

    <div class="right-bar" v-if="currentPage === PAGE.ACCOUNT_INFO">
      <form ref="getStartedFormAccountInfo">
        <div class="logo">
          <img :src="require('../assets/pfx-logo-black.png')" />
          <br />Real Estate Auction Platform
        </div>

        <div class="stepper-indicator">STEP 1/4</div>

        <div class="subheading">Account Information</div>
        <fieldset>
          <label>Email * &mdash; this will be your login name</label>
          <input
            v-model="email"
            id="email"
            type="email"
            placeholder="Enter Email"
            required
            :disabled="alreadyLoggedIn"
            :class="{ error: signUpErrorMessage }"
          />
          <div class="error-message" v-if="signUpErrorMessage">
            <v-icon size="small" color="formerror">error</v-icon>
            {{ signUpErrorMessage }}
          </div>
        </fieldset>
        <fieldset class="clearfix">
          <div class="col12">
            <label>Password *</label>
            <input
              v-model="password1"
              id="password1"
              type="password"
              title="Password must contain at least 8 characters, including UPPER/lowercase, numbers and special characters"
              pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*)(+=._-]).{8,}"
              placeholder="Enter Password"
              required
              minlength="8"
              :disabled="alreadyLoggedIn"
            />
          </div>
          <div class="col12">
            <label>Confirm Password *</label>
            <input
              v-model="password2"
              id="password2"
              type="password"
              title="Password must contain at least 8 characters, including UPPER/lowercase, numbers and special characters"
              pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*)(+=._-]).{8,}"
              placeholder="Enter Password"
              required
              minlength="8"
              :disabled="alreadyLoggedIn"
            />
          </div>
        </fieldset>
        <fieldset>
          <input v-model="acceptTerms" id="accept-terms" type="checkbox" required /> &nbsp;
          <label for="accept-terms">
            I agree to the
            <a
              @click.prevent="$store.dispatch('openTermsAndConditionsPopup')"
            >Terms of Service</a>,
            <a
              @click.prevent="$store.dispatch('openBrokerRegistrationPopup')"
            >Broker Registration Terms</a> and the
            <a @click.prevent="$store.dispatch('openPrivacyPolicyPopup')">Privacy Policy</a> of PFX Real Estate Auction Platform.
            <!-- <a @click.prevent="$store.dispatch('openTermsAndConditionsPopup')">Terms of Service</a> and the
            <a @click.prevent="$store.dispatch('openPrivacyPolicyPopup')">Privacy Policy</a> of PFX Real Estate Auction Platform.-->
          </label>
        </fieldset>

        <div class="subheading">Personal Information</div>
        <fieldset>
          <div class="col12">
            <label>First Name *</label>
            <input v-model="firstName" type="text" placeholder="Enter First Name" required />
          </div>
          <div class="col12">
            <label>Last Name *</label>
            <input v-model="lastName" type="text" placeholder="Enter Last Name" required />
          </div>
        </fieldset>
        <fieldset>
          <div class="col12">
            <label>Professional Title (Optional)</label>
            <input v-model="title" type="text" placeholder="Enter Job Title" />
          </div>
          <div class="col12">
            <label>Cell Phone Number *</label>
            <input
              v-model="phone"
              type="text"
              title="Phone number format must be (123)123-1234567"
              pattern="[(][0-9]{3}[)][0-9]{3}[-][0-9]{4,7}"
              placeholder="Enter Cell Phone Number"
              required
            />
          </div>
        </fieldset>

        <fieldset class="clearfix" style="margin-top: 2em;">
          <div class="col12" style="font-weight: 600; font-size: 14px;">
            <template v-if="!alreadyLoggedIn">
              Already have a PFX Account?
              <br />
              <a @click.prevent="openLogin">Login with your Account</a>
            </template>
            &nbsp;
          </div>
          <div class="col12" style="text-align: right; margin-top: 8px;">
            <button
              class="btn-primary wider"
              style="font-size: 14px;"
              @click.prevent="accountInfoNext"
            >Next</button>
          </div>
        </fieldset>
      </form>
    </div>

    <div class="right-bar" v-else-if="currentPage === PAGE.WELCOME_BACK">
      <div class="logo">
        <img :src="require('../assets/pfx-logo-black.png')" />
        <br />Real Estate Auction Platform
      </div>

      <div class="stepper-indicator">STEP 1/4</div>

      <div class="subheading">Welcome back {{ firstName }} {{ lastName }}!</div>
      <p>
        Uh-oh, looks like you already belong to one Brokerage Account.
        You'll need to sign up with a new email if you would like to continue to start another Brokerage Account.
      </p>
      <AgentCard
        :userProfile="$store.state.user.profile"
        :tenantSubdomain="$store.state.user.tenant"
      />

      <fieldset class="clearfix" style="margin-top: 4em;">
        <div class="col12" style="font-weight: 600; font-size: 14px;">
          <template v-if="alreadyLoggedIn">
            <button class="btn-primary wider" @click.prevent="doLogout">Sign Up Again</button>
          </template>
          &nbsp;
        </div>
        <div class="col12" style="text-align: right; margin-top: 8px;">
          <button
            class="btn-neutral-light wider"
            style="font-size: 14px;"
            @click.prevent="closeGetStarted"
          >Close</button>
        </div>
      </fieldset>
    </div>

    <div class="right-bar" v-else-if="currentPage === PAGE.CONFIRM_ACCOUNT">
      <form ref="getStartedFormConfirm">
        <div class="logo">
          <img :src="require('../assets/pfx-logo-black.png')" />
          <br />Real Estate Auction Platform
        </div>

        <div class="stepper-indicator">STEP 2/4</div>

        <div class="subheading">Confirm Account</div>
        <p>
          Thank you!
          <br />A verification token will be sent to your email to confirm your new account!
          <br />Please check your email and enter your Token below.
        </p>
        <fieldset>
          <label>Enter your Token to verify your account *</label>
          <input
            v-model="confirmationToken"
            type="text"
            autocomplete="off"
            placeholder="Enter Token"
            required
            minlength="6"
          />
          <div class="error-message" v-if="confirmErrorMsg">
            <v-icon size="small" color="formerror">error</v-icon>
            {{ confirmErrorMsg }}
          </div>
        </fieldset>
        <!--
        <fieldset>
          <div style="font-weight: 600; font-size: 14px;">
            Didn't get a Token?<br/>
            <a>Re-send the email</a>
          </div>
        </fieldset>
        -->

        <fieldset class="clearfix" style="margin-top: 2em;">
          <div class="col12">
            <button
              class="btn-neutral-light wider"
              style="font-size: 14px;"
              @click.prevent="toPage(PAGE.ACCOUNT_INFO)"
            >Previous</button>
          </div>
          <div class="col12" style="text-align: right;">
            <button
              class="btn-primary wider"
              style="font-size: 14px;"
              @click.prevent="confirmAccountNext"
            >Next</button>
          </div>
        </fieldset>
      </form>
    </div>

    <div class="right-bar" v-else-if="currentPage === PAGE.COMPANY_DETAILS">
      <form ref="getStartedFormCompanyDetails">
        <div class="logo">
          <img :src="require('../assets/pfx-logo-black.png')" />
          <br />Real Estate Auction Platform
        </div>

        <div class="stepper-indicator">STEP 3/4</div>

        <div class="subheading">Company Details</div>
        <fieldset>
          <label>Company Name *</label>
          <input v-model="companyName" type="text" placeholder="Enter Company Name" required />
        </fieldset>
        <fieldset>
          <label>Choose PFX Website URL * &mdash; allows only characters a-z, 0-9 and dash</label>
          <input
            v-model="subdomain"
            id="subdomain"
            type="text"
            placeholder="Enter Company URL"
            required
            pattern="[a-z0-9\\-]+"
          />
          <div>
            Your own platform website address will be
            <strong>https://{{ subdomain || 'something' }}.pfxinc.com/</strong>
          </div>
        </fieldset>
        <fieldset class="clearfix">
          <div class="col12">
            <label>Company Email *</label>
            <input v-model="companyEmail" type="email" placeholder="Enter Email" required />
          </div>
          <div class="col12">
            <label>Office Phone Number *</label>
            <input
              v-model="companyNumber"
              type="text"
              title="Phone number format must be (123)123-1234567"
              pattern="[(][0-9]{3}[)][0-9]{3}[-][0-9]{4,7}"
              placeholder="Enter Office Phone Number"
              required
            />
          </div>
        </fieldset>
        <fieldset class="clearfix">
          <div class="col12">
            <label>Agent DRE Number *</label>
            <input v-model="agentDreNumber" type="text" placeholder="Enter Agent ID" required />
          </div>
          <div class="col12">
            <label>Company DRE Number *</label>
            <input v-model="companyDreNumber" type="text" placeholder="Enter Company ID" required />
          </div>
        </fieldset>

        <fieldset class="clearfix" style="margin-top: 2em;">
          <div class="col12">
            <button
              class="btn-neutral-light wider"
              style="font-size: 14px;"
              @click.prevent="toPage(PAGE.ACCOUNT_INFO)"
            >Previous</button>
          </div>
          <div class="col12" style="text-align: right;">
            <button
              class="btn-primary wider"
              style="font-size: 14px;"
              @click.prevent="companyDetailsNext"
            >Next</button>
          </div>
        </fieldset>
      </form>
    </div>

    <div class="right-bar" v-else-if="currentPage === PAGE.WAIT_FOR_APPROVAL">
      <div class="logo">
        <img :src="require('../assets/pfx-logo-black.png')" />
        <br />Real Estate Auction Platform
      </div>

      <div class="stepper-indicator">STEP 4/4</div>

      <div class="subheading">Wait for Approval...</div>
      <p>
        Almost there!
        <br />PFX individually reviews Applications to ensure a quality level experience and support.
        We will inform you when your account is ready to go.
      </p>
      <p>
        Please check your email for updates. This can take
        <strong>up to 24 hours</strong>.
        <br />Thank you for your patience.
      </p>
      <p>
        Questions? Call {{ supportPhone }} or send us an email at
        <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>.
      </p>

      <fieldset class="clearfix" style="margin-top: 2em;">
        <div class="col12">
          <button
            class="btn-neutral-light wider"
            style="font-size: 14px;"
            @click.prevent="toPage(PAGE.COMPANY_DETAILS)"
          >Previous</button>
        </div>
        <div class="col12" style="text-align: right;">
          <button
            class="btn-primary wider"
            style="font-size: 14px;"
            @click.prevent="closeGetStarted"
          >Done</button>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
import AgentCard from "./elements/AgentCard.vue";
import {
  cognitoSignUp,
  submitConfirmationToken,
  processLogin
} from "../utils/PfxCognitoFunctions.js";
import { supportEmail, supportPhone, tenantRoles } from "../utils/PfxUtils.js";
import { mapGetters } from "vuex";

const PAGE = {
  ACCOUNT_INFO: 0,
  WELCOME_BACK: 1,
  CONFIRM_ACCOUNT: 2,
  COMPANY_DETAILS: 3,
  WAIT_FOR_APPROVAL: 4
};

export default {
  name: "GetStarted",
  components: {
    AgentCard
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      supportEmail,
      supportPhone,
      PAGE,

      currentPage: PAGE.ACCOUNT_INFO,
      stepper: 1,

      // step 1 data
      email: null,
      signUpErrorMessage: "",
      password1: null,
      password2: null,
      firstName: null,
      lastName: null,
      title: null,
      phone: null,
      acceptTerms: false,

      // step 2 data
      confirmationToken: null,
      confirmErrorMsg: "",

      // step 4 data
      companyName: null,
      subdomain: null,
      companyEmail: null,
      companyNumber: null,
      agentDreNumber: null,
      companyDreNumber: null,

      tenantApplication: {},
      reservedDomains: []
    };
  },
  computed: {
    ...mapGetters(["userId", "fullName", "userPool", "cognitoStorage"]),
    alreadyLoggedIn() {
      return !!this.userId;
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.populateDataOnShow();
      }
    },
    email() {
      this.signUpErrorMessage = "";
    },
    subdomain() {
      this.subdomain = this.subdomain.toLowerCase().replace(/[^a-z0-9\\-]/, "");
    }
  },
  created() {
    this.populateDataOnShow();
  },
  methods: {
    toPage(page) {
      switch (page) {
        case PAGE.ACCOUNT_INFO: {
          this.stepper = 1;
          break;
        }
        case PAGE.WELCOME_BACK: {
          this.stepper = 1;
          break;
        }
        case PAGE.CONFIRM_ACCOUNT: {
          this.stepper = 2;
          break;
        }
        case PAGE.COMPANY_DETAILS: {
          this.stepper = 3;
          break;
        }
        case PAGE.WAIT_FOR_APPROVAL: {
          this.stepper = 4;
          break;
        }
        default:
          this.stepper = 1;
      }
      this.currentPage = page;
    },

    populateDataOnShow() {
      this.signUpErrorMessage = "";
      this.acceptTerms = false;
      if (this.userId) {
        // if user is logged-in
        this.acceptTerms = true;
        this.email = this.$store.state.user.email || "";
        this.password1 = "...............";
        this.password2 = "...............";
        this.firstName = this.$store.state.user.profile.firstName || "";
        this.lastName = this.$store.state.user.profile.lastName || "";
        this.title = this.$store.state.user.profile.title || "";
        this.phone = this.$store.state.user.profile.phone || "";
        this.agentDreNumber = this.$store.state.user.profile.dreNumber || "";

        // load existing application (if one exists for this user account)
        this.$store.commit("setLoadingSpinner", true);
        this.$PfxBackendApi
          .getMyTenantApplication()
          .then(res => {
            console.log("getMyTenantApplication res", res);
            const data = res.data || {};
            if (data.id) {
              this.tenantApplication = data;
              console.log(
                "existing tenant application found",
                this.tenantApplication
              );

              this.companyName = data.name || "";
              this.subdomain = data.subdomain || "";
              this.companyEmail = data.contactEmail || "";
              this.companyNumber = data.contactPhone || "";
              this.companyDreNumber = data.dreNumber || "";

              this.toPage(PAGE.WAIT_FOR_APPROVAL);
            }
          })
          .catch(err => {
            console.error("getMyTenantApplication err", err);
          })
          .then(() => this.$store.commit("setLoadingSpinner", false));
      }
      this.confirmationToken = "";
      this.confirmErrorMsg = "";

      this.$PfxBackendApi
        .getReservedDomains()
        .then(res => {
          console.log("getReservedDomains res", res);
          this.reservedDomains = res.data || [];
        })
        .catch(err => console.error("getReservedDomains err", err));
    },

    openLogin() {
      this.$store.commit("openLoginDialog");
    },
    doLogout() {
      this.$store.dispatch("logout");
      this.email = "";
      this.password1 = "";
      this.password2 = "";
      this.firstName = "";
      this.lastName = "";
      this.title = "";
      this.phone = "";
      this.agentDreNumber = "";
      this.companyName = "";
      this.subdomain = "";
      this.companyEmail = "";
      this.companyNumber = "";
      this.companyDreNumber = "";
      this.signUpErrorMessage = "";
      this.confirmationToken = "";
      this.confirmErrorMsg = "";
      this.toPage(PAGE.ACCOUNT_INFO);
    },
    closeGetStarted() {
      this.$store.commit("closeGetStartedDialog");
      setTimeout(() => this.toPage(PAGE.ACCOUNT_INFO), 1000);
    },

    accountInfoNext() {
      document.getElementById("password1").setCustomValidity("");
      document.getElementById("password2").setCustomValidity("");
      if (!this.$refs.getStartedFormAccountInfo.checkValidity()) {
        this.$refs.getStartedFormAccountInfo.reportValidity();
        return;
      }
      if (!this.alreadyLoggedIn) {
        if (this.password1 !== this.password2) {
          document
            .getElementById("password2")
            .setCustomValidity("Passwords do not match");
          this.$refs.getStartedFormAccountInfo.reportValidity();
          return;
        }

        // creates new user
        const that = this;
        this.$store.commit("setLoadingSpinner", true);
        cognitoSignUp(
          this.userPool,
          this.cognitoStorage,
          this.email,
          this.password1
        )
          .then(() => {
            that.confirmationToken = "";
            that.confirmErrorMsg = "";
            this.toPage(PAGE.CONFIRM_ACCOUNT);
          }) // go to confirm token page
          .catch(errorMsg => (that.signUpErrorMessage = errorMsg))
          .then(() => that.$store.commit("setLoadingSpinner", false));
      } else {
        // no need to create new user account
        // if user is already member of any tenant, show the welcome back page
        if (
          this.$store.state.user.role !== tenantRoles.ANONYMOUS.value ||
          this.$store.state.user.tenant
        ) {
          this.toPage(PAGE.WELCOME_BACK);
        } else {
          // else show the company details page
          this.toPage(PAGE.COMPANY_DETAILS);
        }
      }
    },

    confirmAccountNext() {
      if (!this.$refs.getStartedFormConfirm.checkValidity()) {
        this.$refs.getStartedFormConfirm.reportValidity();
        return;
      }

      const that = this;
      that.confirmErrorMsg = "";
      that.$store.commit("setLoadingSpinner", true);
      submitConfirmationToken(
        this.userPool,
        this.cognitoStorage,
        this.email,
        this.confirmationToken
      )
        .then(() => {
          // autologin
          processLogin(
            this.userPool,
            this.cognitoStorage,
            this.email,
            this.password1
          )
            .then(view => {
              if (view === "after-login") {
                that.$store.dispatch("authorize", {
                  router: that.$router,
                  noActionsAfterLogin: true
                });
                that.toPage(PAGE.COMPANY_DETAILS);
              } else if (view === "secret") {
                // this should never happen
                that.confirmErrorMsg = "Token verification failed?";
                that.$store.commit("setLoadingSpinner", false);
              } else {
                console.error(
                  "unexpected return view from processLogin [%s]",
                  view
                );
                that.confirmErrorMsg =
                  "Unknown error during processing automatic login";
                that.$store.commit("setLoadingSpinner", false);
              }
            })
            .catch(errorMsg => {
              that.confirmErrorMsg = errorMsg;
              that.$store.commit("setLoadingSpinner", false);
            });
        })
        .catch(errorMsg => {
          that.confirmErrorMsg = errorMsg;
          that.$store.commit("setLoadingSpinner", false);
        });
    },

    companyDetailsNext() {
      document.getElementById("subdomain").setCustomValidity("");
      if (!this.$refs.getStartedFormCompanyDetails.checkValidity()) {
        this.$refs.getStartedFormCompanyDetails.reportValidity();
        return;
      }
      if (this.subdomain.startsWith("-") || this.subdomain.endsWith("-")) {
        document
          .getElementById("subdomain")
          .setCustomValidity("Website address cannot start or end with a dash");
        this.$refs.getStartedFormCompanyDetails.reportValidity();
        return;
      }
      if (this.tenantApplication.subdomain !== this.subdomain) {
        if (this.reservedDomains.indexOf(this.subdomain) > -1) {
          // validate if the subdomain is already taken
          document
            .getElementById("subdomain")
            .setCustomValidity(
              "Website address is already reserved. Please choose another one."
            );
          this.$refs.getStartedFormCompanyDetails.reportValidity();
          return;
        }
      }

      this.$store.commit("setLoadingSpinner", true);

      // backend POST to (partial) update user profile
      const userProfile = {
        id: this.$store.state.user.cognitoSubject,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        title: this.title,
        dreNumber: this.agentDreNumber
      };
      this.$PfxBackendApi
        .postUser(userProfile)
        .then(res => {
          console.log("postUser res", res);
          this.$store.commit("setUserProfile", res.data);
        })
        .catch(err => {
          console.error("postUser err", err);
        });

      // backend PUT or POST to update or insert tenant_application
      if (this.tenantApplication.id) {
        // update
        this.tenantApplication.name = this.companyName;
        this.tenantApplication.subdomain = this.subdomain;
        this.tenantApplication.contactEmail = this.companyEmail;
        this.tenantApplication.contactPhone = this.companyNumber;
        this.tenantApplication.dreNumber = this.companyDreNumber;
        this.tenantApplication.additionalInfo = "";

        this.$PfxBackendApi
          .putMyTenantApplication(this.tenantApplication)
          .then(res => {
            console.log("putMyTenantApplication res", res);
            this.toPage(PAGE.WAIT_FOR_APPROVAL);
          })
          .catch(err => {
            console.error("putMyTenantApplication err", err);
            this.$notify({
              type: "danger",
              message: "Unexpected error during updating application"
            });
          })
          .then(() => {
            this.$store.commit("setLoadingSpinner", false);
          });
      } else {
        // insert
        const application = {
          userId: this.$store.state.user.cognitoSubject,
          name: this.companyName,
          subdomain: this.subdomain,
          contactEmail: this.companyEmail,
          contactPhone: this.companyNumber,
          dreNumber: this.companyDreNumber,
          additionalInfo: ""
        };
        this.$PfxBackendApi
          .postTenantApplication(application)
          .then(res => {
            console.log("postTenantApplication res", res);
            this.populateDataOnShow();
          })
          .catch(err => {
            console.error("postTenantApplication err", err);
            this.$notify({
              type: "danger",
              message: "Unexpected error during submitting application"
            });
          })
          .then(() => {
            this.$store.commit("setLoadingSpinner", false);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../pfx.scss";

$sidebar-width: 337px;
.col12 {
  @include column(1/2);
}

.get-started-page {
  position: relative;
  font-size: 12px;
  background-color: #1a6e87;
  color: #fff;

  .left-bar {
    float: left;
    width: $sidebar-width;
    padding: 50px;
    margin-right: 2rem;

    h1 {
      font-size: 24px;
      font-family: "Encode Sans", sans-serif;
      margin: 0;
    }
  }

  .right-bar {
    margin-left: $sidebar-width;
    background-color: #fafafa;
    color: #000;
    padding: 2rem;
    min-height: 550px;

    .logo {
      text-align: center;
      font-size: 14px;
      img {
        width: 96px;
      }
    }

    .step-indicator {
      font-weight: 600;
      color: #4a4a4a;
    }

    .subheading {
      font-weight: 600;
      font-size: 16px;
      margin: 12px 0;
    }

    p {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GetStarted.vue